// sidebarMenuConfig.js

const sidebarMenuConfig = {
  1: [
    // Super Admin — a management & oversight portal under /admin. Kept to what a
    // super admin actually needs: system management (schools/users/roles),
    // catalog & people oversight, financial oversight & policy, and analytics.
    // Day-to-day desk operations (issue/return, parent-request approval) and
    // physical printing (barcodes, spine labels, receipts, cards) belong to the
    // Librarian portal and are intentionally left out. Those routes still exist
    // under /admin, they're just not surfaced here.

    // Management
    { label: 'Dashboard', path: '/admin/dashboard', icon: 'fas fa-tachometer-alt' },
    { label: 'Book List', path: '/librarian/books', icon: 'fas fa-book' },
    { label: 'Book Categories', path: '/librarian/book-categories', icon: 'fas fa-layer-group' },
    { label: 'Book Copies', path: '/librarian/book-copies', icon: 'fas fa-copy' },
    { label: 'Parent Requests', path: '/librarian/reservations', icon: 'fas fa-inbox' },
    { label: 'Issued Book List', path: '/librarian/issues', icon: 'fas fa-book-reader' },
    { label: 'Fine List', path: '/librarian/fines', icon: 'fas fa-file-invoice-dollar' },
    { label: 'Payments', path: '/librarian/payments', icon: 'fas fa-credit-card' },
    { label: 'Refunds', path: '/librarian/refunds', icon: 'fas fa-hand-holding-usd' },
    { label: 'Members', path: '/librarian/members', icon: 'fas fa-users' },
    { label: 'Students Data', path: '/librarian/students', icon: 'fas fa-user-graduate' },
    { label: 'Announcements', path: '/librarian/announcements', icon: 'fas fa-bullhorn' },
    { label: 'Notifications', path: '/librarian/notifications', icon: 'fas fa-bell' },
    { label: 'Barcode Print', path: '/librarian/barcodes', icon: 'fas fa-barcode' },
    { label: 'Spine Labels', path: '/librarian/spine-labels', icon: 'fas fa-tags' },
    { label: 'Library Cards', path: '/librarian/library-cards', icon: 'fas fa-id-card' },
    { label: 'Receipt Print', path: '/librarian/receipt-print', icon: 'fas fa-receipt' },
    { label: 'Reports', path: '/librarian/reports', icon: 'fas fa-chart-bar' },
    { label: 'Schools', path: '/admin/schools', icon: 'fas fa-school' },
    { label: 'Users & Librarians', path: '/admin/librarians', icon: 'fas fa-users-cog' },
    { label: 'Roles', path: '/admin/roles', icon: 'fas fa-user-shield' },

    // Catalog oversight
    { label: 'Book List', path: '/admin/books', icon: 'fas fa-book' },
    { label: 'Book Categories', path: '/admin/book-categories', icon: 'fas fa-layer-group' },

    // People oversight
    { label: 'Members', path: '/admin/members', icon: 'fas fa-users' },
    { label: 'Students Data', path: '/admin/students', icon: 'fas fa-user-graduate' },

    // Finance oversight & policy
    { label: 'Fine List', path: '/admin/fines', icon: 'fas fa-file-invoice-dollar' },
    { label: 'Fine Rules', path: '/admin/fine-rules', icon: 'fas fa-balance-scale' },
    { label: 'Payments', path: '/admin/payments', icon: 'fas fa-credit-card' },
    { label: 'Deposit Ledger', path: '/admin/deposit-ledger', icon: 'fas fa-wallet' },

    // Communication & analytics
    { label: 'Announcements', path: '/admin/announcements', icon: 'fas fa-bullhorn' },
    { label: 'Reports', path: '/admin/reports', icon: 'fas fa-chart-bar' }
  ],

  2: [
    // School Admin — runs a single school end-to-end under /school. Every page is
    // scoped to the admin's own library. Management extras: My School (edit their
    // school's details) and Users & Librarians (staff for their school only).

    // Management
    { label: 'Dashboard', path: '/school/dashboard', icon: 'fas fa-tachometer-alt' },
    { label: 'My School', path: '/school/my-school', icon: 'fas fa-school' },
    { label: 'Users & Librarians', path: '/school/users', icon: 'fas fa-users-cog' },

    // Catalog
    { label: 'Book List', path: '/school/books', icon: 'fas fa-book' },
    { label: 'Book Categories', path: '/school/book-categories', icon: 'fas fa-layer-group' },
    { label: 'Book Copies', path: '/school/book-copies', icon: 'fas fa-copy' },

    // Circulation
    { label: 'Issue Book', path: '/school/issues/create', icon: 'fas fa-share' },
    { label: 'Parent Requests', path: '/school/reservations', icon: 'fas fa-inbox' },
    { label: 'Issued Book List', path: '/school/issues', icon: 'fas fa-book-reader' },
    { label: 'Overdue Books', path: '/school/overdue', icon: 'fas fa-exclamation-triangle' },

    // People
    { label: 'Members', path: '/school/members', icon: 'fas fa-users' },
    { label: 'Students Data', path: '/school/students', icon: 'fas fa-user-graduate' },

    // Finance
    { label: 'Fine List', path: '/school/fines', icon: 'fas fa-file-invoice-dollar' },
    { label: 'Fine Rules', path: '/school/fine-rules', icon: 'fas fa-balance-scale' },
    { label: 'Payments', path: '/school/payments', icon: 'fas fa-credit-card' },
    { label: 'Refunds', path: '/school/refunds', icon: 'fas fa-hand-holding-usd' },
    { label: 'Deposit Ledger', path: '/school/deposit-ledger', icon: 'fas fa-wallet' },

    // Communication, printing & analytics
    { label: 'Announcements', path: '/school/announcements', icon: 'fas fa-bullhorn' },
    { label: 'Notifications', path: '/school/notifications', icon: 'fas fa-bell' },
    { label: 'Library Cards', path: '/school/library-cards', icon: 'fas fa-id-card' },
    { label: 'Barcode Print', path: '/school/barcodes', icon: 'fas fa-barcode' },
    { label: 'Spine Labels', path: '/school/spine-labels', icon: 'fas fa-tags' },
    { label: 'Receipt Print', path: '/school/receipt-print', icon: 'fas fa-receipt' },
    { label: 'Reports', path: '/school/reports', icon: 'fas fa-chart-bar' },

    // Account
    { label: 'My Profile', path: '/school/my-profile', icon: 'fas fa-user' }
  ],

  3: [
    // Librarian
    { label: 'Dashboard', path: '/librarian/dashboard', icon: 'fas fa-tachometer-alt' },
    { label: 'Book List', path: '/librarian/books', icon: 'fas fa-book' },
    { label: 'Parent Requests', path: '/librarian/reservations', icon: 'fas fa-inbox' },
    { label: 'Issued Book List', path: '/librarian/issues', icon: 'fas fa-book-reader' },
    // { label: 'Renewals', path: '/librarian/renewals', icon: 'fas fa-sync-alt' },
    // { label: 'Fine Rules', path: '/librarian/fine-rules', icon: 'fas fa-balance-scale' },
    { label: 'Fine List', path: '/librarian/fines', icon: 'fas fa-file-invoice-dollar' },
    { label: 'Payments', path: '/librarian/payments', icon: 'fas fa-credit-card' },
    { label: 'Refunds', path: '/librarian/refunds', icon: 'fas fa-hand-holding-usd' },
    // { label: 'Deposit Ledger', path: '/librarian/deposit-ledger', icon: 'fas fa-wallet' },
    { label: 'Members', path: '/librarian/members', icon: 'fas fa-users' },
    { label: 'Students Data', path: '/librarian/students', icon: 'fas fa-user-graduate' },
    // { label: 'Student Import', path: '/librarian/student-import', icon: 'fas fa-file-import' },
    // { label: 'Book Import', path: '/librarian/book-import', icon: 'fas fa-file-upload' },
    { label: 'Announcements', path: '/librarian/announcements', icon: 'fas fa-bullhorn' },
    { label: 'Notifications', path: '/librarian/notifications', icon: 'fas fa-bell' },
    { label: 'Barcode Print', path: '/librarian/barcodes', icon: 'fas fa-barcode' },
    { label: 'Spine Labels', path: '/librarian/spine-labels', icon: 'fas fa-tags' },
    { label: 'Library Cards', path: '/librarian/library-cards', icon: 'fas fa-id-card' },
    { label: 'Receipt Print', path: '/librarian/receipt-print', icon: 'fas fa-receipt' },
    { label: 'Reports', path: '/librarian/reports', icon: 'fas fa-chart-bar' }
  ],

  5: [
    // Parent
    { label: 'Dashboard', path: '/parent-dashboard', icon: 'fas fa-tachometer-alt' },
    { label: 'Book List', path: '/parent-book-list', icon: 'fas fa-book' },
    { label: 'My Requests', path: '/parent-requests', icon: 'fas fa-inbox' },
    { label: 'Issued Books', path: '/parent-issued-books', icon: 'fas fa-book-reader' },
    { label: 'My Fines', path: '/parent-fines', icon: 'fas fa-file-invoice-dollar' },
    { label: 'My Payments', path: '/parent-payments', icon: 'fas fa-credit-card' },
    { label: 'Library Card', path: '/parent-library-card', icon: 'fas fa-id-card' },
    { label: 'Profile', path: '/parent-profile', icon: 'fas fa-user' }
  ]
};

export default sidebarMenuConfig;